import api from '../api'
import { mapActions } from 'vuex'
import moment from 'moment'

const rolesArray = [
  { name: 'shared.after_printer', id: 'ROLE_AFTER_PRINTER' },
  { name: 'shared.printer', id: 'ROLE_PRINTER' },
  { name: 'shared.designer', id: 'ROLE_DESIGNER' },
  { name: 'shared.manager', id: 'ROLE_MANAGER' },
  { name: 'shared.director', id: 'ROLE_ADMIN' },
  { name: 'shared.master', id: 'ROLE_MASTER' },
  { name: 'shared.accountant', id: 'ROLE_ACCOUNTANT' },
  { name: 'shared.ad_agent', id: 'ROLE_AD_AGENT' }
]

export default {
  name: 'activityStream',
  props: ['isActivityViewVisible'],
  data: function () {
    return {
      messagesData: [],
      customerId: this.$store.state.userInfo.customer.id,
      activityId: 0
    }
  },
  computed: {
    messages () {
      return this.messagesData.slice().reverse()
    }
  },
  methods: {
    loadActivityStream () {
      const self = this
      api.get
        .activityStream()
        .then(resp => {
          resp.data.data.activities.forEach(function (data) {
            self.setMessage(data)
          })
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    },
    activateStream () {
      const self = this
      this.$store.state.webSocket.on('socket/connect', function (session) {
        session.subscribe(
          `api/ws/activity/customer/${self.customerId}`,
          function (uri, payload) {
            const parsedPayload = JSON.parse(payload)
            if (parsedPayload.stream === 'all') {
              self.setMessage(parsedPayload.event)
              if (parsedPayload.event.action === 'SetedRequest') {
                self.updateRequest(parsedPayload.event.payload.id)
              }
              if (parsedPayload.event.action === 'DeletedRequest') {
                self.refreshRequests()
              }
            }
            if (parsedPayload.stream === 'task') {
              self.updateTask(parsedPayload.event.id)
            }
            if (parsedPayload.comment) {
              self.updateTask(parsedPayload.task.id)
            }
          }
        )
      })
    },
    getUserRoleName (roleId) {
      return this.$t(rolesArray.find(x => x.id === roleId).name)
    },
    getMessageAction (action) {
      switch (action) {
        case 'DeleteEmployee':
          return 'Удалил(-а) сотрудника'
        case 'AddNewEmployee':
          return 'Добавил(-а) сотрудника'
        case 'UpdatePostEmployee':
          return 'Изменил(-а) должность сотрудника'
        case 'SetedTask':
          return 'Поставил(-а) задачу'
        case 'PausedTask':
          return 'Отправил(-а) задачу на паузу'
        case 'FinishedTask':
          return 'Завершил(-а) задачу'
        case 'TaskOnStock':
          return 'Отправил(-а) задачу на склад'
        case 'TaskOnContract':
          return 'Отправил(-а) задачу на подряд'
        case 'SetedRequest':
          return 'Разместил(-а) заявку'
        default:
          return ''
      }
    },
    getMessageText (data) {
      switch (data.action) {
        case 'DeleteEmployee':
          return `${data.payload.firstname} ${data.payload.lastname}`
        case 'AddNewEmployee':
          return `Эл. почта - ${data.payload.email}`
        case 'UpdatePostEmployee':
          return `У ${data.payload.firstname} ${
            data.payload.lastname
          } новая должность - ${this.getUserRoleName(data.payload.change.new)}`
        case 'SetedTask':
        case 'PausedTask':
        case 'FinishedTask':
        case 'TaskOnStock':
        case 'TaskOnContract':
        case 'SetedRequest':
          return `"${data.payload.name}"`
        default:
          return ''
      }
    },
    getActionPillData (data) {
      switch (data.action) {
        case 'DeleteEmployee':
        case 'AddNewEmployee':
        case 'UpdatePostEmployee':
          return {
            content: '<i class="ico ico-men"></i>',
            isTaskUpdate: false,
            isRequestUpdate: false
          }
        case 'SetedTask':
        case 'PausedTask':
        case 'FinishedTask':
        case 'TaskOnStock':
        case 'TaskOnContract':
          return {
            content: `${data.payload.ctid}`,
            id: data.payload.id,
            isTaskUpdate: true,
            isRequestUpdate: false
          }
        case 'SetedRequest':
          return {
            content: `${data.payload.local_id}`,
            id: data.payload.id,
            isTaskUpdate: false,
            isRequestUpdate: true
          }
        default:
          return null
      }
    },
    setMessage (data) {
      const msg = {
        userName: `${data.initiator.firstname} ${data.initiator.lastname}`,
        messageText: this.getMessageText(data),
        actionPillData: this.getActionPillData(data),
        action: this.getMessageAction(data.action),
        time:
          moment()
            .startOf('day')
            .diff(moment(data.datetime).startOf('day'), 'days') > 0
            ? moment(data.datetime).format('DD MMM HH:mm')
            : moment(data.datetime).format('HH:mm'),
        id: this.activityId++
      }
      if (msg.actionPillData) {
        this.messagesData.push(msg)
      }
      if (
        !this.isActivityViewVisible &&
        moment(data.datetime).diff(
          moment(this.$store.state.appSettings.activityVisitTime)
        ) > 0
      ) {
        this.$eventBus.$emit('addUnreadedActivityMessage')
      }
    },
    scrollToStart () {
      const container = this.$el.querySelector('.activity-stream-messages')
      container.scrollTop = 0
    },
    ...mapActions({
      updateTask: 'UPDATE_TASK',
      updateRequest: 'UPDATE_REQUEST',
      refreshRequests: 'LOAD_OUTGOING_TASKS'
    })
  },
  created () {
    this.activateStream()
    this.loadActivityStream()
  },
  mounted () {
    this.$eventBus.$on('onShowActivityView', () => {
      this.$nextTick(function () {
        this.scrollToStart()
      })
    })
  }
}
